import axios from 'axios';

export function useAxios() {
  // Here you can set up your default axios configurations if needed
  // For example, setting the base URL or any global headers
  
  return { axios };
}